/* unplugin-vue-components disabled */import { render } from "./EarTraining808Render.vue?vue&type=template&id=ee5efedc&scoped=true"
import script from "./EarTraining808Render.vue?vue&type=script&lang=js"
export * from "./EarTraining808Render.vue?vue&type=script&lang=js"

import "./EarTraining808Render.vue?vue&type=style&index=0&id=ee5efedc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee5efedc"]])

export default __exports__